import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize, TextType} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Button, IconPlacement, Size, Type} from '@Components/button';
import styles from './stock-panel-error.module.scss';

export interface StockPanelErrorProps {
  text: string;
  onRefresh?: () => void;
  className?: string;
}

function StockPanelError({...props}: StockPanelErrorProps): ReactElement {
  return (
    <div className={`flex-center flex-v-row ${styles.container} ${props.className ?? ''}`}>
      <div className={`${styles.iconContainer} spacing-p-6 radius-round`}>
        <Icon className="color-danger-100" icon="icon-exclamation-triangle" size={IconSize.SIZE_ICON_32} type={IconType.NONE} shape={IconShape.NONE} />
      </div>
      <Text className="content-body text-center" val={props.text} type={TextType.BODY} size={TextSize.SMALL} />
      {props.onRefresh ? <Button size={Size.SMALL} type={Type.SECONDARY} icon="icon-refresh" text="Refresh" iconPlacement={IconPlacement.LEFT} onClick={props.onRefresh} /> : null}
    </div>
  );
}

export default StockPanelError;
